import { render } from "./CommunityOverviewCard.vue?vue&type=template&id=0a69eca2&scoped=true"
import script from "./CommunityOverviewCard.vue?vue&type=script&lang=ts"
export * from "./CommunityOverviewCard.vue?vue&type=script&lang=ts"

import "./CommunityOverviewCard.vue?vue&type=style&index=0&id=0a69eca2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a69eca2"

export default script